module.exports = '2.1.8';



//////////////////
// WEBPACK FOOTER
// ./~/graphlib/lib/version.js
// module id = 1629
// module chunks = 0